/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-07-14 23:17:49
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-15 10:44:41
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/ProductsSelection/ProductSelectionWithHsCode/HsCode/index.tsx
 */
import css from './css.module.less';
import React from 'react';
import _ItemWrapper from '@/src/components/Layouts/Item/Item';
import {
  SearchSelect, //Select
} from 'src/components/Antd';
import { addSupplier, getProductsByHsCode } from 'src/request/common/hsCode';
import _ from 'lodash';
import { Spin, Empty } from 'antd';
import { useHsPreload } from './hooks';
import { replaceI18nVariables } from '@/src/tools/tools';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

//import { EDangerousType } from 'src/types/common/product';
// const _dOptions = [
//   {
//     label: 'Explosives',
//     value: EDangerousType.Explosives,
//   },
//   {
//     label: 'Gases',
//     value: EDangerousType.Gases,
//   },
//   {
//     label: 'Flammable Liquids',
//     value: EDangerousType.FlammableLiquids,
//   },
//   {
//     label: 'Oxidizing And Peroxide',
//     value: EDangerousType.OxidizingAndPeroxide,
//   },
//   {
//     label: 'Toxic',
//     value: EDangerousType.Toxic,
//   },
//   {
//     label: 'Radioactive',
//     value: EDangerousType.Radioactive,
//   },
//   {
//     label: 'Corrosive',
//     value: EDangerousType.Corrosive,
//   },
//   {
//     label: 'Miscellaneous',
//     value: EDangerousType.Miscellaneous,
//   },
// ];
const HsCode = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    onHsCodesChange,
    // onClassesChange,
    hsCodes,
    dangerousGoodsClasses,
    onHsProductChange,
    error,
  } = props;

  const [fetching, setFetching] = React.useState(false);
  const [hsCodesOptions, setHsCodesOptions] = React.useState([]);
  const { handleOnHsCodeDropdownChange } = useHsPreload(
    hsCodesOptions,
    setHsCodesOptions,
    addSupplier,
  );
  const _key = React.useMemo(() => {
    const _hsCodes = hsCodes.map((i) => i.value);
    const _dangerousGoodsClasses = dangerousGoodsClasses.map((i) => i.value);
    return {
      hsCodePrefix: _hsCodes[0] || '',
      dangerousGoodsClasses: _dangerousGoodsClasses,
    };
  }, [hsCodes, dangerousGoodsClasses]);

  const hsHasData = React.useMemo(() => {
    return _key.dangerousGoodsClasses.length > 0 || _key.hsCodePrefix;
  }, [_key]);

  React.useEffect(() => {
    if (onHsProductChange)
      if (hsHasData) {
        getProductsByHsCode(_key).then((res) => {
          onHsProductChange(res);
        });
      } else {
        onHsProductChange([]);
      }
  }, [_key]);

  const _hsCodesOptions = React.useMemo(() => {
    return hsCodesOptions.map((i) => {
      return {
        label: `${i.code} ${i.description}`,
        value: i.uuid,
        code: i.code,
        description: i.description,
      };
    });
  }, [hsCodesOptions]);

  const searchHsCode = (text) => {
    if (text.length > 0) {
      setFetching(true);
      // setHsCodes([]);
      addSupplier(0, 50, { hsCodePrefix: text }).then((codes) => {
        const { results } = codes;
        setHsCodesOptions(results);
        setFetching(false);
      });
    }
  };

  return (
    <div className={css.container}>
      <ItemWrapper>
        <SearchSelect
          placeholder={replaceI18nVariables(
            getI18n('general.selectAndSearchPlaceholder'),
            getI18n('storeTaxes.taxEditPage.hSCode'),
          )}
          onDropdownVisibleChange={handleOnHsCodeDropdownChange}
          className={css.hsCode}
          mode='multiple'
          notFoundContent={
            fetching ? (
              <Spin size='small' />
            ) : (
              <Empty
                description={getI18n(
                  'general.linkModule.Components.NoResult.no_result',
                )}
              />
            )
          }
          onSearch={_.debounce(searchHsCode, 500)}
          optionsList={_hsCodesOptions}
          size='large'
          showArrow
          labelInValue
          allowClear
          onChange={onHsCodesChange}
          value={hsCodes}
        />
      </ItemWrapper>
      {/* <ItemWrapper
        title='Class of Dangerous Goods'
        containerClassName={css.noPadding}>
        <Select
          placeholder='Select...'
          allowClear
          mode='multiple'
          size='large'
          showArrow
          labelInValue
          optionsList={_dOptions}
          onChange={onClassesChange}
          value={dangerousGoodsClasses}
        />
      </ItemWrapper>{' '} */}
      {error && <div className={css.errContainer}>{error}</div>}
    </div>
  );
};
export default HsCode;

const ItemWrapper = (props) => {
  const { children, containerClassName, ...rest } = props;
  return (
    <_ItemWrapper
      containerClassName={`${containerClassName || ''} ${css.overwriteCss} `}
      {...rest}>
      {children}
    </_ItemWrapper>
  );
};
